import { render, staticRenderFns } from "./asset_picture_desc.vue?vue&type=template&id=383fd5a8&scoped=true&lang=pug&"
import script from "./asset_picture_desc.vue?vue&type=script&lang=js&"
export * from "./asset_picture_desc.vue?vue&type=script&lang=js&"
import style0 from "./asset_picture_desc.vue?vue&type=style&index=0&id=383fd5a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383fd5a8",
  null
  
)

export default component.exports